export const getPaginationSize = (dataLength: number, limit: number) => {
  return Math.ceil(dataLength / limit);
};
